import { LiHTMLAttributes } from 'react'

export const TextListItem = ({ children }: LiHTMLAttributes<HTMLLIElement>) => {
  return (
    <li className="list-disc py-0.5 pl-2">
      <span className="inline-block align-top">{children}</span>
    </li>
  )
}
